"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _colorUtils = require("../../../shared/colorUtils");
var _jsxRuntime = require("react/jsx-runtime");
/* deprecated - replaced by WorkSignifier */
var StyledIdIcon = _styledComponents.default.div.withConfig({
  displayName: "ColoredIdIcon__StyledIdIcon",
  componentId: "sc-1wfpltb-0"
})(["display:inline-block;", ";border-radius:", ";padding:", " ", ";white-space:nowrap;"], _tokens.default.sky.sys.font.subheading['2'], _globalTokens.globalBorder.radius['2'], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['200']);

/* deprecated - replaced by WorkSignifier - will be removed */
function ColoredIdIcon(_ref) {
  var children = _ref.children,
    color = _ref.color;
  var theme = (0, _styledComponents.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIdIcon, {
    style: {
      backgroundColor: color,
      color: (0, _colorUtils.getTextColor)(color, theme)
    },
    children: children
  });
}
ColoredIdIcon.defaultProps = {
  color: _globalTokens.globalColor.id['4']
};
var _default = exports.default = ColoredIdIcon;